/**
 * Keeps a "Ships by …" date current.
 *
 * The date is worked out in Liquid so it is there without script, but pages are
 * served from cache and a cached date goes stale overnight. This recomputes it
 * on the visitor's clock with the same rules: orders placed after the cutoff
 * hour count from the next day, and only weekdays count as handling days.
 */
class ShipsByDate extends HTMLElement {
  connectedCallback() {
    const leadDays = Number(this.dataset.leadDays ?? 1);
    const cutoffHour = Number(this.dataset.cutoffHour ?? 12);
    const target = this.querySelector('[data-ship-date]');
    if (!target || Number.isNaN(leadDays) || Number.isNaN(cutoffHour)) return;

    const date = new Date();
    if (date.getHours() >= cutoffHour) date.setDate(date.getDate() + 1);

    let remaining = leadDays;
    for (let step = 0; step < 21; step += 1) {
      const weekday = date.getDay();
      const isBusinessDay = weekday !== 0 && weekday !== 6;
      if (isBusinessDay && remaining === 0) break;
      if (isBusinessDay) remaining -= 1;
      date.setDate(date.getDate() + 1);
    }

    target.textContent = date.toLocaleDateString(document.documentElement.lang || undefined, {
      weekday: 'short',
      month: 'short',
      day: 'numeric',
    });
  }
}

if (!customElements.get('ships-by-date')) {
  customElements.define('ships-by-date', ShipsByDate);
}
